import dismisser from './storage/dismiss-storage';

var dismissed = function(delays){
    
    var delaysCount, delay, dismissedCount;
    
    if (typeof (delays) === 'undefined') return false;
    if (typeof (delays) === 'number') delays = [delays];
    dismissedCount = dismisser.count();
    delaysCount = delays.length;
    delay = delays[Math.min(dismissedCount, delaysCount) - 1];
    return !dismisser.dismissOlderThan(delay * 60 * 60);
}

export default dismissed;


//////////////////
// WEBPACK FOOTER
// ./src/utils/dismissed.js
// module id = 16
// module chunks = 0